/** Two-line device option row in Select / Autocomplete dropdowns (no icons). */
export const DEVICE_OPTION_CONTENT_ROW_PX = 54;
